import { Outlet, NavLink, useLocation } from "react-router-dom";
import "../styles/Dashboard.css";

export default function Dashboard() {
  const location = useLocation();
  const isBooking = location.pathname.includes("/dashboard/bookings");

  return (
    <div className="dashboard__container">
      <div className="dashboard__contents--container">
        <div
          className={`dashboard__content ${isBooking ? "dashboard__content--bookings" : ""}`}
        >
          {/* Leftside side bar */}
          <aside className="dashboard__sidebar--container">
            <div className="dashboard__sidebar--categories">
              <h2>Bookings</h2>
              <NavLink to="bookings">
                <button className="dashboard__sidebar--button my-btn my-btn:hover">
                  Bookings
                </button>
              </NavLink>
            </div>

            <div className="dashboard__sidebar--categories">
              <h2>Users</h2>
              <NavLink to="users">
                <button className="dashboard__sidebar--button my-btn my-btn:hover">
                  Users
                </button>
              </NavLink>
              <NavLink to="registerAdmin">
                <button className="dashboard__sidebar--button my-btn my-btn:hover">
                  Register
                </button>
              </NavLink>
              <NavLink to="logout">
                <button className="dashboard__sidebar--button my-btn my-btn:hover">
                  Logout
                </button>
              </NavLink>
            </div>
          </aside>

          {/* Main content */}
          <main className="dashboard__main">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
